import { Colors, Media, Spacing } from '@doordash/design-language'
import styled from 'styled-components'

export const RootContainer = styled.div`
  max-width: 50rem;
  width: 100%;
  background: ${Colors.SystemWhite};
  border-radius: ${Spacing.XxxSmall}px;
  border: 1px solid ${Colors.BorderPrimary};
  margin-bottom: ${Spacing.XxLarge}px;
  padding: ${Spacing.XxxLarge}px;
  ${Media.Tablet`
    border: 0px;
    margin-bottom: 0px;
    padding: ${Spacing.Large}px;
  `};
  ${Media.Mobile`
    border: 0px;
    margin-bottom: 0px;
    padding: ${Spacing.XSmall}px;
  `};
`

export default RootContainer
